export default __webpack_public_path__ + "static/media/charm-6.5f8e26c1.png";